// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from './Message';
import { DirectQuoteMessage } from './DirectQuoteMessage';
import { HistoryType } from '../History/HistoryType';
export class DirectQuote4Message extends DirectQuoteMessage {
    constructor() {
        super(Message.CODE_QUOTE4);
        this.Underlier = null;
        this.Last = null;
        this.Bid = Number.NaN;
        this.Ask = Number.NaN;
        this.BidSize = Number.NaN;
        this.AskSize = Number.NaN;
        this.PrevClose = null;
        this.High = null;
        this.Low = null;
        this.LastSize = 0;
        this.Volume = null;
        this.Open = null;
        this.OpenInterest = 0;
        this.Type = HistoryType.QUOTE_OPTIONS;
    }
    static CreateFromQuote1(q1m, option) {
        const q4m = new DirectQuote4Message();
        if (!q1m || !option) {
            return q4m;
        }
        q4m.Underlier = option.SourceName;
        q4m.Route = q1m.Route;
        q4m.Bid = q1m.Bid;
        q4m.BidSize = q1m.BidSize;
        q4m.Ask = q1m.Ask;
        q4m.AskSize = q1m.AskSize;
        q4m.Open = q1m.Open;
        q4m.High = q1m.High;
        q4m.Low = q1m.Low;
        q4m.PrevClose = q1m.PrevClose;
        q4m.Volume = q1m.TotalVolume;
        q4m.Last = q1m.LastPice;
        q4m.LastSize = q1m.LastSize;
        q4m.OpenInterest = q1m.OpenInterest;
        q4m.Time = q1m.cTime;
        q4m.PutCall = option.PutCall;
        q4m.ExpYear = option.ExpDate.Year;
        q4m.ExpMonth = option.ExpDate.Month;
        q4m.ExpDay = option.ExpDate.Day;
        q4m.StrikePrice = option.StrikePrice;
        return q4m;
    }
}
